import gql from 'graphql-tag';

export default gql`
  query flightsPageTranslations {
    application(name: DESKTOPBOOKINGPATH) {
      ... on DesktopBookingPath {
        translations(language: enUS) {
          common {
            continueButtonLabel
            taxesChargesFeesPopupContent
            operatedByLabel
            tripTotalLabel
          }
          flightsPage {
            flightsPageHeading
            noFlightsResultsText
            flightsPageDisclaimerText
            flightsPageDisclaimerPopupWindowTitle
            roundTripSavingsValue
            roundTripSavingsDescription
            roundTripCancelButtonLabel
            roundTripBannerDescriptionTitle
            roundTripBannerDescriptionText
            roundTripBannerCallToAction
            roundTripDiscountDisclaimerText
            noFlightsStateText
            missingFlightsErrorTitle
            missingFlightsErrorMessage
            calendarDesktopDepartDateLabel
            calendarMobileDepartDateLabel
            calendarDesktopReturnDateLabel
            calendarMobileReturnDateLabel
            calendarDesktopDepartAndReturnDateLabel
            calendarMobileDepartAndReturnDateLabel
            listViewButtonText
            calendarViewButtonText
            loyaltyFareDiscountHeading
            newFareLabelHTML
            mainFareLabelHTML
            newFareNotAvailableLabelHTML
          }
          flightsSearchResults {
            departingFlightHeading
            departingFlightOriginLabel
            departingFlightDestinationLabel
            returningFlightHeading
            returningFlightOriginLabel
            returningFlightDestinationLabel
          }
          flightDetails {
            originTitle
            destinationTitle
          }
          flightsErrors {
            warningDepartingAfterReturning
            errorDepartingAfterReturning
            errorReturningBeforeDeparting
            errorDefaultMessage
          }
          flightItem {
            flightNumberLabel
            departureTimeLabel
            arrivalTimeLabel
            limitedSeatsAvailability
            availableSeats
            selectedFlightText
            isOvernight
            selectFlightLabel
            returnFlightBeforeArrival
            loyaltyDiscountedPriceText
            loyaltyDiscountedPricePointsText
            loyaltyDiscountedPriceDefaultText
          }
          flightItemWithBundle{
            bundleAndSaveDepartingFlightLabelHTML
            bundleAndSaveReturningFlightLabelHTML
            collapseAllLabelHTML
            expandAllLabelHTML
            addedSelectedBundleLabelHTML
            noBundleLabelHTML
            bagsIncludeLabelHTML
            personalItemLabelHTML
            carryOnLabelHTML
            checkedBagLabelHTML
            totalBundleSeatOptionsLabelHTML
            bonusBundleSeatOptionsLabelHTML
            basicBundleSeatOptionsLabelHTML
            priorityBoardingLabelHTML
            tripFlexLabelHTML
            enhancedTripFlexLabelHTML
            tripFlexOFOPLabelHTML
            tripFlexInfoDescription
            tripFlexOFOPInfoDescriptionHTML
            priorityBoardingInfoDescription
            skipBundleButtonLabelHTML
            enhancedTripFlexResponsiveLabelHTML
            newFareDepartureLabelHTML
            newFareReturnLabelHTML
            newFareSeatOptionsLabelHTML
            newFareCheckedBagLabelHTML
            newFareBagsTooltipTextHTML
            newFareDepartureLabelHTML
            newFareReturnLabelHTML
            newFareBenefitsFirstPointLabelHTML
            newFareBenefitsSecondPointLabelHTML
            newFareBenefitsThirdPointLabelHTML
            newFareBannerTitleHTML
            newFareBannerDescriptionHTML
            newFareTripflexLabelHTML
            newFareRefundBenefitLabelHTML
            newFareDepartureResponsiveLabelHTML
            newFareReturnResponsiveLabelHTML
            selectButtonLabelHTML
            newFareAddedLabelHTML
            newFareSeatOptionsTitleHTML
            bundleSeatOptionsTitleHTML
            personalItemResponsiveLabelHTML
            carryOnResponsiveLabelHTML
            checkedBagResponsiveLabelHTML
            mainSeatOptionResponsiveLabelHTML
            allSeatOptionsResponsiveLabelHTML
            tripFlexResponsiveLabelHTML
            priorityBoardingResponsiveLabelHTML
            enhancedTripFlexResponsiveLabelHTML
          }
          bundlesPage {
            bundlePageTextAssociatedWithCurrentPrice
          }
          otpPopover {
            otpContentHeading
            otpOnTimeArrivalLabel
            otpThirtyMinuteLateLabel
            otpCancellationsLabel
            otpNoDataMessage
          }
          stadiumPackages {
            gameDayLabel
          }
        }
        configurations {
          seatsAvailabilityThreshold
          enableAllegiantFirst
        }
      }
    }
  }
`;
